import { useStore } from '../store';
import type { EditorState } from '@xsscool/shared';

// Subscribes to each field individually so that React's useSyncExternalStore
// gets stable snapshots: using a selector that returns a new object every
// call causes infinite render loops in React 18.
export function useEditorState(): EditorState {
  const status = useStore((s) => s.status);
  const delay = useStore((s) => s.delay);
  const chunks = useStore((s) => s.chunks);
  const chunkDelay = useStore((s) => s.chunkDelay);
  const payloadParam = useStore((s) => s.payloadParam);
  const editorLanguage = useStore((s) => s.editorLanguage);
  const editorContent = useStore((s) => s.editorContent);
  const headers = useStore((s) => s.headers);
  return { status, delay, chunks, chunkDelay, payloadParam, editorLanguage, editorContent, headers };
}
